import { render, staticRenderFns } from "./PccOrderCustomsPropertiesEdit.vue?vue&type=template&id=1fa59d58&scoped=true&"
import script from "./PccOrderCustomsPropertiesEdit.vue?vue&type=script&lang=js&"
export * from "./PccOrderCustomsPropertiesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa59d58",
  null
  
)

export default component.exports